module.exports = __webpack_public_path__ + "img/preview.d8d309bb.svg";